module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Заказы печати\n    "), (_vm.total) ? _c('span', [_vm._v("(" + _vm._s(_vm.total) + ")")]) : _vm._e()]), _vm._v(" "), _c('resource-list', {
    attrs: {
      "url": "/print-orders",
      "current-sort": "datetime",
      "resource-name": "print_orders",
      "show-per-page": false,
      "fields": _vm.fields,
      "filters": _vm.filters
    },
    on: {
      "total": _vm.updateTotal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87b1d286","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/print_order/PrintOrders.vue
// module id = 681
// module chunks = 0